//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import template from './bulk-actions-remove-from-connect-modal.html';
import './bulk-actions-remove-from-connect-modal.less';

import { ICuralateStore } from '@models/AppState';
import { IShareMediaItem } from '@share/models/shareStateModel';
import getSharedItemsEligibleToRemove from '@share/selectors/getSharedItemsEligibleToRemove';

import angular from 'angular';
import { INgRedux } from 'ng-redux';

import { getBulkActionsSelectedItems } from 'app/bulk-actions/selectors/bulk-actions-selector';

export class BulkActionsRemoveFromConnectModal {
  private static mapStateToThis(state: ICuralateStore) {
    return {
      selectedItems: getBulkActionsSelectedItems(state),
      sharedItems: state.share.data.items,
      sharedItemsEligibleToRemove: getSharedItemsEligibleToRemove(state),
    };
  }

  public selectedItems: any[];
  public sharedItems: IShareMediaItem[];
  public sharedItemsEligibleToRemove: IShareMediaItem[];

  public elligbleToRemoveItems: number;
  public inelligbleToRemoveItems: number;

  private unsubscribe: () => void;

  constructor($ngRedux: INgRedux) {
    this.unsubscribe = $ngRedux.connect(
      BulkActionsRemoveFromConnectModal.mapStateToThis,
    )(this);
  }

  public $onChanges() {
    this.elligbleToRemoveItems = this.sharedItemsEligibleToRemove.length;
    this.inelligbleToRemoveItems =
      this.selectedItems.length - this.sharedItemsEligibleToRemove.length;
  }

  public $onDestroy() {
    this.unsubscribe();
  }
}

angular.module('curalate').component('bulkActionsRemoveFromConnectModal', {
  bindings: {
    confirmationCta: '@',
    confirmationMessage: '@',
    onCancel: '&',
    onComplete: '&',
    requiredPermission: '@',
  },
  controller: ['$ngRedux', BulkActionsRemoveFromConnectModal],
  template,
});
